import './index.less';

import React from 'react';

const FullScreen = ({children}) => <div className="fullscreen">{children}</div>;

export default FullScreen;
